/* eslint-disable no-plusplus */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import Base from '../../_config/base';

class Timeline extends Base {
  constructor(el) {
    super(el);

    const slider = el.querySelector('.swiper-timeline');

    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const sliderOpt = {
      modules: [Navigation],
      speed: 500,
      longSwipes: true,
      keyboard: {
        enabled: true,
      },
      allowTouchMove: !isMobile,
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3.1,
        },
        1440: {
          slidesPerView: 4.2,
        },
      },
      navigation: {
        nextEl: '.swiper-button-nextTimestamp',
        prevEl: '.swiper-button-prevTimestamp',
      },
    };

    // eslint-disable-next-line
    const swiper = new Swiper(slider, sliderOpt);

    /* eslint-disable no-unused-vars */
    // const swiper = new Swiper('.swiper-timeline', {
    //   // initialSlide: 1,
    //   modules: [Navigation, Pagination],
    //   speed: 500,
    //   longSwipes: true,
    //   keyboard: {
    //     enabled: true,
    //   },
    //   breakpoints: {
    //     // when window width is >= 320px
    //     320: {
    //       slidesPerView: 1,
    //       // direction: 'vertical',
    //     },
    //     // when window width is >= 768px
    //     768: {
    //       slidesPerView: 2.2,
    //       // direction: 'horizontal',
    //     },
    //     // when window width is >= 1024px
    //     1024: {
    //       slidesPerView: 3.1,
    //     },
    //     // when window width is >= 1440px
    //     1440: {
    //       slidesPerView: 4.2,
    //     },
    //   },
    //   navigation: {
    //     nextEl: '.swiper-button-nextTimestamp',
    //     prevEl: '.swiper-button-prevTimestamp',
    //   },
    // });
  }
}

Timeline.className = 'Timeline';
export default Timeline;
